import React, { useEffect } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Paper } from "@mui/material";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { useSelector } from "react-redux";
import { inventoryTableHead } from "../../../components/datagrid/assetmanagement/InventoryTableHead";
import { useDispatch } from "react-redux";
import {
  getInventoryData,
  getSale,
} from "../../../redux/features/assetManagementSlice";
import { NewInventoryTableHead } from "../../../components/datagrid/assetmanagement/NewInventoryTableHead";

const InventoryLanding = () => {
  const dispatch = useDispatch();
  const { inventoryData, loading } = useSelector(
    (state) => state.assetmanagement
  );
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search, rowData } = paginationData;
  const dispatchParams = {
    paginationData,
  };
  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getInventoryData(dispatchParams));
    }
  }, [gridSize, pageNum, search]);
  return (
    <GlobalWrapper title={"Inventory"}>
      <Box>
        <Paper>
          <GlobalDatagrid
            tableHead={NewInventoryTableHead}
            rows={inventoryData?.data}
            meta={inventoryData?.meta?.totalRecords || 0}
            loading={loading}
            rowUniqueId="sl_no"
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default InventoryLanding;
